const $ = require("jquery");
import run from "../../utilities/run";
import moment from 'moment';
import { setElementsFromScope } from "../../utilities/selectorHelpers";
import timePicker from "../../components/timePicker/timePicker";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import generateDatePicker from "../../utilities/datePicker";
import { instantiateSelect2 } from "../../utilities/select2able";

const targetSelector = ".order-hold-rule-new-edit";

run(targetSelector, mainEl => {
  const els = {};
  const elsMap = {
    ruleIdEl: ".rule-id",
    ruleSkuEl: ".rule-sku",
    ruleOrderTypeEl: ".rule-order-type",
    rulePosLocationEl: ".rule-pos-location",
    ruleReleaseDateEl: ".rule-release-date",
    ruleReleaseTimeEl: ".rule-release-time",
    saveReleaseRuleBtn: ".save-release-rule-btn",
    cancelReleaseRuleBtn: ".cancel-release-rule-btn",
    duplicateRuleAlert: ".duplicate-rule-alert",
    duplicateRuleAlertLink: ".duplicate-rule-alert-link"
  };

  const submitRuleUrl = mainEl.data("submit-rule-url");
  const cancelRuleLookupUrl = mainEl.data("cancel-rule-lookup-url");
  const cancelRuleDetailsUrl = mainEl.data("cancel-rule-details-url");
  const ruleData = mainEl.data("rule-data");
  let ruleReleaseTimePickerEl;
  let formValidator;

  function init() {
    generateDatePicker($('.rules-datepicker'));
    setElements();
    bindElements();
    initTimePicker();
    setValuesIfEdit();
    setValidator();
  }

  function setValuesIfEdit(){
    if(ruleData){
      els.ruleSkuEl.val(ruleData.sku);
      els.ruleOrderTypeEl.val(ruleData.orderType).trigger('change');
      els.ruleReleaseDateEl.val(ruleData.releaseDate);

      if(ruleData.posLocation){
        const values = ruleData.posLocation.split(",");
        const optionsHtml = values.map(value => {
          return `<option value="${value}">${value}</option>`
        }).join("")
        els.rulePosLocationEl.html(optionsHtml);

        els.rulePosLocationEl.val(values);
      }

      const releaseDateTime = moment(`${ruleData.releaseDate} ${ruleData.releaseTime}`, 'MM/DD/YYYY hh:mm A');
      ruleReleaseTimePickerEl.setTimeFromMilitary(releaseDateTime.format("HH:mm"));
    }
  }

  function setElements() {
    setElementsFromScope(els, elsMap, mainEl);
  }

  function bindElements() {
    els.saveReleaseRuleBtn.on("click", saveReleaseRule);
    els.cancelReleaseRuleBtn.on("click", cancelReleaseRule);
  }

  function setValidator(){
    formValidator = mainEl.find('#rule-form').validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    });
    formValidator.settings.ignore = ":disabled,:hidden";
  }
  
  function cancelReleaseRule(e){
    e.preventDefault();
    if(ruleData){
      window.location.href = `${cancelRuleDetailsUrl}&cbrId=${ruleData.ruleId}`;
    }else{
      window.location.href = cancelRuleLookupUrl;
    }
  }
  
  function saveReleaseRule(e) {
    e.preventDefault();
    if(mainEl.find('#rule-form').valid()){
      saveReleaseRuleModalFlow.showConfirmModal();
    }
  }


  let saveReleaseRuleModalFlow = new SubmitModalFlow({
    confirmModalTitle: "Save Rule",
    modalDialogClass: "q-modal-dialog-500",
    confirmModalBody: `<div class="q-marg-all-xl">
                         Once this rule is saved it will be held until the rule meets it's specified release time, or is manually released.
                       </div>`,
    confirmModalBtnText: "Save",
    onConfirmClick: function() {
      saveReleaseRuleModalFlow.showLoadingModal();
      els.duplicateRuleAlert.hide();

        const data = generateSubmitData()
        submitRule(data);

        function submitRule(data, rule) {
          $.ajax({
            url: submitRuleUrl,
            type: "POST",
            dataType: "JSON",
            data,
            success: function(data) {
              if (data.response == "success") {
                saveReleaseRuleModalFlow.showSuccessModal();
                window.location.href = `${cancelRuleDetailsUrl}&cbrId=${data.ruleId}`;
              } else if (data.response == "exists") {
                saveReleaseRuleModalFlow.hideAllModals();
                els.duplicateRuleAlert.show();
                els.duplicateRuleAlertLink.attr("href", `${cancelRuleDetailsUrl}&cbrId=${data.ruleId}`)
              } else {
                saveReleaseRuleModalFlow.showFailureModal();
              }
            },
            error: function(data) {
              saveReleaseRuleModalFlow.hideAllModals();
            }
          });
        }
    }
  });

  function generateSubmitData(){
    const data = {}

    data.ruleId = els.ruleIdEl.val();
    data.sku = els.ruleSkuEl.val();
    data.orderType = els.ruleOrderTypeEl.val();
    data.posLocation = els.rulePosLocationEl.val().join(",");
    data.releaseDate = els.ruleReleaseDateEl.val();

    const time = ruleReleaseTimePickerEl.getMilitaryTime();
    if(time != "Invalid date"){
      data.releaseTime = time;
    }

    return data;
  }

  saveReleaseRuleModalFlow.init();

  function initTimePicker() {
    ruleReleaseTimePickerEl = new timePicker(els.ruleReleaseTimeEl);
  }

  init();
});



// WEBPACK FOOTER //
// ./src/pages/orderHoldRuleNewEdit/index.js